import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const TextBodyStyled = styled.p<{ width?: string }>`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) =>
    props.theme.atlas.semantic.color.action.destructive.default};
  width: ${(props) => props.width ?? 'max-content'};
  margin: 0;
`;
